import { render } from "./IPProductListView.vue?vue&type=template&id=aecc8790&ts=true"
import script from "./IPProductListView.vue?vue&type=script&lang=ts"
export * from "./IPProductListView.vue?vue&type=script&lang=ts"

import "./IPProductListView.vue?vue&type=style&index=0&id=aecc8790&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__